import { SEND_TRACKING_REQUEST } from './constants'

export const sendTrackingRequestAction = payload => ({
  type: SEND_TRACKING_REQUEST,
  payload,
  track: true,
})
